function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { MotivatorChart } from "../../../models";
import { attuned_theme } from "../../../styles/theme";
import { BarChart, PieChart } from "echarts/charts";
import { PolarComponent } from "echarts/components";
/**
 * Donut chart representation of singular Motivator datum.
 * @class MotivatorsDonutChart
 * @extends MotivatorChart
 */ export var MotivatorsDonutChart = /*#__PURE__*/ function(MotivatorChart) {
    "use strict";
    _inherits(MotivatorsDonutChart, MotivatorChart);
    function MotivatorsDonutChart(_param) {
        _class_call_check(this, MotivatorsDonutChart);
        var _this;
        var tmp = _param.options, ref = _object_destructuring_empty(tmp === void 0 ? {} : tmp), _param_theme = _param.theme, theme = _param_theme === void 0 ? attuned_theme : _param_theme, _param_formatter = _param.formatter, formatter = _param_formatter === void 0 ? null : _param_formatter, _param_useMotivatorColors = _param.useMotivatorColors, useMotivatorColors = _param_useMotivatorColors === void 0 ? false : _param_useMotivatorColors, _param_radius = _param.radius, radius = _param_radius === void 0 ? 100 : _param_radius, _param_datum = _param.datum, datum = _param_datum === void 0 ? {} : _param_datum, _param_eventCallbacks = _param.eventCallbacks, eventCallbacks = _param_eventCallbacks === void 0 ? [] : _param_eventCallbacks, opts = _extends({}, _object_destructuring_empty(_param.options));
        _this = _call_super(this, MotivatorsDonutChart, [
            theme,
            useMotivatorColors,
            [
                PolarComponent,
                BarChart,
                PieChart
            ],
            eventCallbacks
        ]);
        _this.options = _object_spread({
            animation: true,
            tooltip: {},
            polar: {
                radius: radius
            },
            radiusAxis: {
                type: 'category'
            },
            angleAxis: {
                type: 'value',
                max: 100,
                startAngle: 90
            },
            series: [
                {
                    type: 'bar',
                    silent: true,
                    coordinateSystem: 'polar',
                    barWidth: 20,
                    itemStyle: {
                        opacity: 0.5,
                        color: function(param) {
                            var data = param.data;
                            return _this.motivatorColor(data.id, data.percentage);
                        }
                    }
                },
                {
                    type: 'pie',
                    itemStyle: {
                        color: function(param) {
                            var data = param.data;
                            return _this.motivatorColor(data.id, data.percentage);
                        }
                    },
                    tooltip: {
                        formatter: function(param) {
                            var data = param.data;
                            return "".concat(data.motivator, ": ").concat(data.percentage, "%");
                        }
                    },
                    label: {
                        position: 'center',
                        color: 'white',
                        fontSize: 13,
                        fontWeight: 'bold',
                        width: 95,
                        overflow: 'break',
                        padding: 4,
                        formatter: formatter !== null && formatter !== void 0 ? formatter : [
                            '{m_percentage| {@percentage}%}\n',
                            '{m_motivator| {b}}'
                        ].join('\n'),
                        rich: {
                            m_percentage: {
                                fontSize: 18,
                                lineHeight: 22,
                                align: 'center'
                            },
                            m_motivator: {
                                fontSize: 12,
                                align: 'center',
                                lineHeight: 15
                            }
                        }
                    },
                    radius: radius / 2
                }
            ],
            dataset: {
                dimensions: [
                    'motivator',
                    'percentage'
                ],
                source: [
                    datum
                ]
            }
        }, opts);
        return _this;
    }
    _create_class(MotivatorsDonutChart, [
        {
            key: "applyDataset",
            value: function applyDataset() {
                var datum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.applyOptions({
                    dataset: _object_spread_props(_object_spread({}, this.options.dataset), {
                        source: [
                            datum
                        ]
                    })
                });
            }
        }
    ]);
    return MotivatorsDonutChart;
}(MotivatorChart);

//# sourceMappingURL=MotivatorsDonutChart.js.map